import { useState } from "react";
import UserContext from "./components/UserContext";
import App from "./App";
const WrapApp = () => {
  const [loggedUser, setLoggedUser] = useState({
    admin: false,
    loggedIn: true,
    clientId: "",
    userName: "",
  });
  return (
    <UserContext.Provider value={[loggedUser, setLoggedUser]}>
      <App />
    </UserContext.Provider>
  );
};

export default WrapApp;
